import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = '/recaudacion/mercancias-decomisos/';

/**
 * GET Mercancias Decomisos
 * @returns {Promise<Array<object>>}
 */
export const getMercanciasDecomisos = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Detalle de Usuario
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getMercanciaDecomiso = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Mercancia Decomiso
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postMercanciaDecomiso = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Detalle De Usuario
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchMercanciaDecomiso = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Mercancia Decomiso
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteMercanciaDecomiso = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
